import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { BrowserStorageService } from '../../services/browser-storage.service';
import { EncryptionService } from '../../services/encryption.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {

  constructor(private router: Router, private storage: BrowserStorageService, private encryptionService: EncryptionService, @Inject(PLATFORM_ID) private platformId: Object) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // En SSR no hay localStorage; evitar redirecciones que causan parpadeo
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }

    const encryptedAccessToken = this.storage.getSessionStorageItem('access');
    const encryptedUser = this.storage.getSessionStorageItem('user');

    if (encryptedAccessToken && encryptedUser) {
      try {
        const accessToken = this.encryptionService.decrypt(encryptedAccessToken);
        const storagedUser = JSON.parse(this.encryptionService.decrypt(encryptedUser));

        if (accessToken && storagedUser && storagedUser.is_active) {
          return true;
        }
      } catch (e) {
        console.error('Error decrypting access token:', e);
      }
    }
    return this.router.createUrlTree(['/login']);
  }
}